function toast(message) {
    const element = document.querySelector('.gh-toast');
    if (!element) return;

    element.textContent = message;
    element.classList.add('is-visible');
    clearTimeout(toast.timer);
    toast.timer = setTimeout(function () {
        element.classList.remove('is-visible');
    }, 2000);
}

/* Formats a date the same way as partials/date.hbs: 2026年10月19日 14:30 */
function formatDate(value) {
    const timeZone = document.documentElement.getAttribute('data-timezone') || undefined;
    let parts;

    try {
        parts = new Intl.DateTimeFormat('zh-CN', {
            timeZone: timeZone,
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
        }).formatToParts(new Date(value));
    } catch (e) {
        return '';
    }

    const get = function (type) {
        const part = parts.find(function (p) { return p.type === type; });
        return part ? part.value : '';
    };

    return get('year') + '年' + get('month') + '月' + get('day') + '日 ' + get('hour') + ':' + get('minute');
}
